/**
 * 复用进行中的请求：并发调用时共享同一个 Promise，请求结束后释放
 *
 * baseRequest 会取消重复的 pending 请求，被取消方的 Promise 永远不会 settle，
 * 多个组件同时请求同一接口时会导致其中一方拿不到数据；用它包一层即可避免。
 * 只合并并发调用，不做结果缓存，不会读到过期数据。
 */
export function shareInflight<R>(request: () => Promise<R>): () => Promise<R> {
  let inflight: Promise<R> | null = null

  return () => {
    if (!inflight) {
      inflight = request().finally(() => {
        inflight = null
      })
    }

    return inflight
  }
}
